var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"banner",style:(_vm.picture)},[_c('div',{staticClass:"page-title"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('h1',{staticClass:"lead"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }